import { render, staticRenderFns } from "./choiceScenic.vue?vue&type=template&id=f1ca1fc8&scoped=true&"
import script from "./choiceScenic.vue?vue&type=script&lang=js&"
export * from "./choiceScenic.vue?vue&type=script&lang=js&"
import style0 from "./choiceScenic.vue?vue&type=style&index=0&id=f1ca1fc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ca1fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ca1fc8')) {
      api.createRecord('f1ca1fc8', component.options)
    } else {
      api.reload('f1ca1fc8', component.options)
    }
    module.hot.accept("./choiceScenic.vue?vue&type=template&id=f1ca1fc8&scoped=true&", function () {
      api.rerender('f1ca1fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/strategy/choiceScenic.vue"
export default component.exports